import React from "react";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { makeProfile } from "@client.pages/Login/reducer";
import UserRoles from "@client.enums/userRoles";
import Pages from "@client.enums/pages";

export const RequireRole = ({ roles }) => {
  const profile = useSelector(makeProfile);
  const context = useOutletContext();
  const isAvailable = profile && roles.indexOf(profile.role) > -1;

  return isAvailable ? (
    <Outlet context={context} />
  ) : (
    <Navigate to={Pages.DashboardOwn} />
  );
};

RequireRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.oneOf(Object.values(UserRoles)))
    .isRequired,
};
